<div class="row row-sm">
    <app-study-options></app-study-options>
</div>
<div class="row row-sm">

    <h4>
    Que significac que no hay citas?
    </h4>
    https://www.parainmigrantes.info/no-hay-citas-disponibles-que-significa-479/

    <h3>Homologación título</h3>
    <mat-card>
        Homologación de títulos extranjeros de educación superior a títulos oficiales universitarios españoles de Grado o Máster que den acceso a profesión regulada en España

        https://universidades.sede.gob.es/pagina/index/directorio/Homologaciones_InfoGeneral
        
        https://universidades.sede.gob.es/procedimientos/portada/ida/3513/idp/1029
        
        https://www.educacionyfp.gob.es/servicios-al-ciudadano/catalogo/general/05/050580/ficha.html
        
        Crear cuenta en la Sede Electrónica
        Rellenar formulario físico
        Rellenar formulario digital en la Sede Electrónica
        Pagar la tasa 107
        Subir la documentación a la Sede Electrónica 
    </mat-card>

    <mat-card>
        Procedimiento Visado estudiante GUATEMALA

        https://www.exteriores.gob.es/es/ServiciosAlCiudadano/Paginas/Servicios-consulares.aspx?scco=Guatemala&scd=148&scca=Visados&scs=Visados+Nacionales+-+Visado+de+estudios 

        https://www.creguatemala.es/embajada-de-espa%C3%B1a-en-guatemala-y-belice

        “Lugar de presentación: La entrega del expediente se programará por medio de cita previa, enviando un correo electrónico a emb.guatemala.vis@maec.es, indicando en el asunto "Att. Cita Visado".Por favor, solicítela con tiempo suficiente, dentro de un período de máximo de 90 días previos a la fecha de inicio de la actividad formativa. De lo contrario, la cita se asignará dependiendo de la disponibilidad.” 
    </mat-card>
    <p>
        VERITAS
        El dpto de Study Abroad se dedican solo a recibir estudiantes no envían. Ahí hay que hablar con cada escuela de la Universidad para preguntar.
        Pamela Badilla


        ————————
        cada una de las escuelas
        Pamela Badilla
        Programas internacionales
        U. Véritas
        ——————
    </p>

    <p>
    Diferencias entre master oficial y máster propio	https://www.uab.cat/web/estudiar/masters-y-postgrados/masters-y-postgrados-propios/-que-diferencias-hay-entre-un-master-oficial-y-un-master-propio-1345713249357.html
    </p>

    <p>
            ESPAÑA <> COSTA RICA

            "Programas de becas españoles:
             El Ministerio de Educación, Cultura y Deporte de España: http://www.mecd.gob.es/servicios-al-ciudadano-mecd/becas-ayudas.html
             El Ministerio de Asuntos Exteriores y de Cooperación y la Agencia Española de Cooperación Internacional para el Desarrollo (AECID): http://www.aecid.es/ES/becas-y- lectorados/convocatorias-maec-aecid
             El Ministerio de Economía, Industria y Competitividad, buscador de ayudas: http://www.idi.mineco.gob.es/portal/site/MICINN/menuitem.29bfd64be21cddc5f09dfd10 01432ea0/?vgnextoid=fae4b9746e160210VgnVCM1000001034e20aRCRD&vgnextcha nnel=fae4b9746e160210VgnVCM1000001034e20aRCRD
             Becas del Instituto de Turismo de España del Ministerio de Energía, Turismo y Agenda Digital: http://www.minetad.gob.es/es- ES/servicios/AyudasPublicas/Paginas/Becas-Turismo.aspx
             Servicio español para la internacionalización de la educación (SEPIE): http://sepie.es/internacionalizacion/programas.html
             Muchas Comunidades Autónomas ofrecen becas a los ciudadanos iberoamericanos para estudiar en España.
             Fundación Carolina: https://www.fundacioncarolina.es
             Becas Santander: http://www.becas-santander.com
             Becas La Caixa: https://obrasociallacaixa.org/es/educacion-becas
             Las propias universidades españolas, tanto privadas como públicas, suelen incluir programas de becas, por lo que se recomienda consultar sus páginas web regularmente.
            "

            "- Programas de becas o préstamos para estudios de Costa Rica para estudiar en España:
             Centro Nacional de Alta Tecnología (CENAT): http://www.cenat.ac.cr/cenat/programa-de-becas
             Consejo Nacional de Préstamos para Educación (CONAPE): http://www.conape.go.cr/informacion-general/#quefinanciamos
            "

            "- Programas de becas internacionales:
             Becas Erasmus Mundus (Unión Europea): http://eacea.ec.europa.eu/erasmus_mundus/funding/scholarships_students_academics _en.php
             Becas Universia (Iberoamérica, mecenazgo Santander): http://becas.universia.net
             Becas Asociación Universitaria Iberoamericana de Posgrado (AUIP):
            http://www.auip.org/es/becasauip
             Fundación Beca: https://www.fundacionbeca.net"

            "- Buscadores de becas, entre otros muchos:
            o Instituto Cervantes:
            http://www.cervantes.es/bibliotecas_documentacion_espanol/becas_extranjero s_espana/becas_universidades.htm
            o Portal Eurobecas: http://www.eurobecas.com.ar/ o Becas sin fronteras: http://www.becas-sin-
            fronteras.com/listado.php?t=paises&destino=España o Universia: http://becas.universia.net/"

    </p>


    <table>
        <tr>
            <th>Ciudad</th>
            <th>Universidad</th>
            <th>Rama de estudio</th>
            <th>Link</th>
        </tr>
        <tr>
            <td>Barcelona</td>
            <td>EAE</td>
            <td>Marketing</td>
            <td><a href="">https://www.eae.es/full-time/master-in-digital-marketing/presentacion</a></td>
        </tr>
        <tr>
            <td>Barcelona</td>
            <td>EAE</td>
            <td>Marketing</td>
            <td><a href="">  https://formacion.eaeprogramas.es/master-marketing-digital-comercio-electronico?c=I10111M3095&gclid=Cj0KCQjwrs2XBhDjARIsAHVymmRO03HgGEMFqghtEUYsq4dQhyPXit-amhtn8ipQ4x3qYKlefKWR4sUaAqz7EALw_wcB</a></td>
        </tr>
        <tr>
            <td>Barcelona</td>
            <td>UAB</td>
            <td>Marketing</td>
            <td><a href=""> https://www.uab.cat/web/postgrau/master-en-comunicacion-y-marketing-digital/informacion-general-1206597472083.html/param1-2220_es/</a></td>
        </tr>
        <tr>
            <td>Barcelona</td>
            <td>UAB</td>
            <td>Marketing</td>
            <td><a href="https://www.mastermarketingdigital.com/"> https://www.mastermarketingdigital.com/</a></td>
        </tr>
        <tr>
            <td>Barcelona</td>
            <td>UB</td>
            <td>Marketing</td>
            <td><a href="https://www.ub.edu/mastermarketingdigital/">https://www.ub.edu/mastermarketingdigital/</a></td>
        </tr>
        <tr>
            <td>Barcelona</td>
            <td>UPF</td>
            <td>Marketing</td>
            <td><a href="https://www.upf.edu/web/masters/marqueting">https://www.upf.edu/web/masters/marqueting</a></td>
        </tr>

    </table>

    <p>
    Listado de Ranking		https://www.gradomania.com/noticias_universitarias/las-25-mejores-universidades-de-espana-segun-el-ranking-de-forbes-org-7147.html					
        https://miformacion.eu/mejores-universidades-espana/privadas/					
        https://universidadesprivadas.de/espana/					
        https://www.eleconomista.es/nacional/noticias/11226466/05/21/Estas-son-las-20-mejores-universidades-de-Espana-segun-Forbes-precios-y-en-que-destacan.html					
                            
    </p>


    <h3>Programas de becas o préstamos para estudios en Costa Rica</h3>
    <div class="flex" *ngFor="let post of pageContent8">
    <p>{{post.topic}}</p>
    <a href="post.link" target="_blank">link</a>
    </div>

    <h3>Programas de becas internacionales</h3>
    <div class="flex" *ngFor="let post of pageContent9">
        <div class="flex-column">
            <p>{{post.title}}</p>
            <p>{{post.topic}}</p>
        </div>
        <a href="post.link" target="_blank">link</a>
    </div>
    <!-- 
    Barcelona	La Salle	Marketing			https://www.salleurl.edu/en/education/master-digital-marketing
    Barcelona	UPF	Data/Business Analytics			https://www.bsm.upf.edu/en/master-science-management-business-analytics#gs.98neup
    Barcelona	ESADE	Data/Business Analytics			https://www.esade.edu/executive-education/es/executive-master/titulo-de-experto-en-business-analytics
    Barcelona	ESADE	Data/Business Analytics			https://www.esade.edu/executive-education/es/executive-master/executive-master-in-business-analytics-emiba
    Barcelona	UPF	Emprendimiento/Innovación			https://www.bsm.upf.edu/en/master-science-management-entrepreneurship#gs.98nuva
    Barcelona	UPF	Logística/SCM			https://www.bsm.upf.edu/en/master-science-management-supply-chain#gs.98nxk3
    Barcelona/Madrid	ESADE	Finanzas	Maestria		https://www.esade.edu/executive-education/es/executive-master/executive-master-en-finanzas-emf
    Barcelona/Madrid	ESADE	Marketing			https://www.esade.edu/executive-education/es/executive-master/executive-master-en-marketing-y-ventas-emmv
    -->

    https://formacion.eaeprogramas.es/master-marketing-digital-comercio-electronico?c=I10111M3095&gclid=Cj0KCQjwrs2XBhDjARIsAHVymmRO03HgGEMFqghtEUYsq4dQhyPXit-amhtn8ipQ4x3qYKlefKWR4sUaAqz7EALw_wcB

    UAB  Universidad Autónoma de Barcelona

    https://www.uab.cat/web/postgrau/master-en-comunicacion-y-marketing-digital/informacion-general-1206597472083.html/param1-2220_es/

    https://www.mastermarketingdigital.com/

    UB - Universitat de Barcelona
    https://www.ub.edu/mastermarketingdigital/

    Universidad Pompeu Fabra
    https://www.upf.edu/web/masters/marqueting

    Universidad de La Salle
    https://www.salleurl.edu/en/education/master-digital-marketing

    Master en Marketing Digital

    EAE Business School
    <a href="https://www.eae.es/full-time/master-in-digital-marketing/presentacion" target="_blank">https://www.eae.es/full-time/master-in-digital-marketing/presentacion</a>

    <div>
        <h6 class="main-content-label mb-1">Información Universidades/Master para los clientes</h6>
        <p class="text-muted  card-sub-title">Recursos para ayudar a los clientes a encontrar una Universidad</p>
    </div>
    <h4 class="font-weight-semibold tx-16">Información de Universidades y Programas de Master para los clientes</h4>

        Comuinidad de MAdrid
        https://www.comunidad.madrid/servicios/transporte/muevete-transporte-publico#:~:text=L%C3%ADneas-,El%20horario%20general%20de%20servicio%20durante%20todos%20los%20d%C3%ADas%20del,servicio%20nocturno%2C%20conocido%20como%20B%C3%BAho.


        UNIVESIDADES

        Esto incluye Universidad Pompeu Fabra, தி Universidad Autónoma de Barcelona Y esto Universidad de Navarra.	      
        Becas QUITO <> España: http://www.exteriores.gob.es/Embajadas/QUITO/es/Embajada/AgregaduriaCultural/Actividades%20culturalesyeducativas/Paginas/Becas.aspx						
                
        https://trabajarporelmundo.org/category/becas/						
                
        CR <> España :						
        http://www.exteriores.gob.es/Embajadas/SANJOSEDECOSTARICA/es/InformacionParaExtranjeros/Paginas/Estudiar.aspx						
                
        https://www.universia.es/						
                
        https://www.rree.go.cr/?sec=servicios&cat=becas&cont=625&letra=E						      
        file:///C:/Users/User/Downloads/Becas%20Costa%20Rica_2020.pdf						
                
        https://www.rree.go.cr/?sec=servicios&cat=becas&cont=579&beca=4351						   
        https://www.uah.es/es/admision-y-ayudas/becas/Becas-UAH-Santander-Iberoamerica.-Estudiantes-de-Grado.Curso-2020-21/						
                
        Holanda: https://www.rree.go.cr/?sec=servicios&cat=becas&cont=579&beca=4349						     
        Francia: https://trabajarporelmundo.org/programa-de-becas-de-excelencia-eiffel/						
                
        emprendedurismo: https://masterschool.eitdigital.eu/						
                
        https://www.elmundo.cr/costa-rica/ofrecen-becas-para-estudiantes-costarricenses-en-espana/						  
        http://www.becasparacostarricenses.com/						
            

        LIINKS PARA ESTUDIAR ENOLOGIA			
        https://yaq.es/carreras-universitarias/ciencias/enologia			  
        https://www.urv.cat/es/estudios/grados/oferta/graudenologia/			
        https://www.emagister.com/curso-universitario-enologia-enologo-sommelier-certificado-academico-emitido-instituto-ciencias-e-cursos-3643378.htm?pfichas=26248&gclid=Cj0KCQiAyoeCBhCTARIsAOfpKxjJiAu3kFTlgoFdeTPXtD9CwJWeE9YA5tqcd_KxqiQFB2913X6xJGIaArClEALw_wcB			
        https://cursosinem2021.com/c-curso-inem-2021-enologia			
        https://web.escueladecata.com/escueladecata			
        https://escueladelvino.com/			
        https://www.cursosypostgrados.com/formacion/enologia.html			  
        https://www.drinksco.es/blog/donde-estudiar-enologia-y-otros-cursos-relacionados-con-el-vino			  
        https://www.educaweb.com/cursos/enologia-viticultura/			   
        https://www.columbia.co.cr/noticias/economia/educacion/27763-fundacion-carolina-ofrece-mas-de-500-becas-para-estudiar-en-espana			 
        https://www.gradosunirioja.es/grado-en-enologia			 
        https://www.estudiahosteleria.com/enologia	
</div>
